import { Slot } from '@radix-ui/react-slot';
import React from 'react';

export type StopPropagationProps = {
  children: React.ReactElement;
};
const stopPropagation = (e: React.SyntheticEvent) => {
  e.stopPropagation();
};

/**
 * A component that stops event propagation for mouse events on its child.
 * Useful when rendering content in portals (like dropdowns, popovers) where
 * you don't want clicks to bubble up to parent elements in the React tree.
 *
 * Stops propagation for: onClick, onMouseDown, onMouseUp
 */
export const StopPropagation = React.forwardRef<
  React.ElementRef<typeof Slot>,
  StopPropagationProps
>(({ children }, ref) => (
  <Slot
    ref={ref}
    onClick={stopPropagation}
    onMouseDown={stopPropagation}
    onMouseUp={stopPropagation}
    onKeyDown={stopPropagation}
    onKeyUp={stopPropagation}
    onPointerDown={stopPropagation}
    // onPointerMove={stopPropagation} // turned off so dnd-kit on document receives pointermove and can track the drag
    // onPointerUp={stopPropagation} // turned off so dnd-kit on document receives pointerup and can end the drag (onDragEnd)
    onDoubleClick={stopPropagation}
  >
    {children}
  </Slot>
));
StopPropagation.displayName = 'StopPropagation';
